/* eslint-disable */
import { createReducer, on, Action } from "@ngrx/store";
import * as AuthActions from "./forgot-password.actions";

export const FORGOT_PASSWORD_FEATURE_KEY = "forgot-password";

export interface ForgotPasswordState {
    loading: boolean,
    succeeded: boolean,
    email: string | undefined,
    error: any | undefined,
}

export const initialAuthState: ForgotPasswordState = {
    loading: false,
    succeeded: false,
    email: undefined,
    error: null,
};

const forgotPasswordReducerInternal = createReducer(
    initialAuthState,
    on(AuthActions.forgotPassword, (state, {email}) => {
        return {
            ...state,
            loading: false,
            succeeded: false,
            email: email,
            error: null,
        };
    }),
    on(AuthActions.forgotPasswordComplete, (state, {}) => {
        return {
            ...state,
            loading: false,
            succeeded: true,
            error: null,
        };
    }),
    on(AuthActions.forgotPasswordFailure, (state, {error}) => {
        return {
            ...state,
            loading: false,
            succeeded: false,
            error,
        };
    }),
    on(AuthActions.clearState, (state, {}) => {
        return {
            ...state,
            loading: false,
            succeeded: false,
            email: undefined,
            error: null,
        };
    }),
);

export function forgotPasswordReducer(state: ForgotPasswordState | undefined, action: Action) {
    return forgotPasswordReducerInternal(state, action);
}
